var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor openai-web-search" },
    [
      !_vm.channel
        ? _c(
            "section",
            [
              _c("a-result", {
                attrs: {
                  status: "warning",
                  title: _vm.$t("chatbotv2.openaiWebSearchNoConnection"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "extra",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center",
                            },
                            [
                              _c(
                                "SupsisButton",
                                {
                                  attrs: { primary: "", ghost: "" },
                                  on: { click: _vm.gotoOpenai },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbotv2.openaiWebSearchConnect")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2090457514
                ),
              }),
            ],
            1
          )
        : [
            _c("section", { staticClass: "active-connection" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "active-connection-text" }, [
                _c("div", [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("chatbotv2.openaiWebSearchConnected"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b", [_vm._v("OpenAI")]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editor-row" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.openaiWebSearchQuery"))),
                ]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: {
                    placeholder: _vm.$t("chatbotv2.openaiWebSearchQueryPh"),
                    "show-attributes": true,
                    "show-emoji": false,
                  },
                  model: {
                    value: _vm.clone.query,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "query", $$v)
                    },
                    expression: "clone.query",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editor-row" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("chatbotv2.openaiWebSearchContextSize"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    model: {
                      value: _vm.clone.search_context_size,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "search_context_size", $$v)
                      },
                      expression: "clone.search_context_size",
                    },
                  },
                  [
                    _c("a-select-option", { attrs: { value: "low" } }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.openaiWebSearchLow"))),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "medium" } }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.openaiWebSearchMedium"))),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "high" } }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.openaiWebSearchHigh"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "editor-row" },
              [
                _c("div", { staticClass: "editor-row-title" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.openaiIncludeDomains"))),
                ]),
                _vm._v(" "),
                _vm._l(_vm.clone.include_domains, function (domain, index) {
                  return _c(
                    "div",
                    { key: "domain-" + index, staticClass: "key-value-pair" },
                    [
                      _c("a-input", {
                        staticClass: "domain-input",
                        attrs: {
                          placeholder: _vm.$t("chatbotv2.openaiDomainPh"),
                        },
                        model: {
                          value: _vm.clone.include_domains[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.include_domains, index, $$v)
                          },
                          expression: "clone.include_domains[index]",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "link", danger: "" },
                          on: {
                            click: function ($event) {
                              return _vm.removeDomain(index)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("delete"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-btn",
                    attrs: { type: "dashed", block: "" },
                    on: { click: _vm.addDomain },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("add"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("chatbotv2.openaiAddDomain")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "logos", attrs: { "data-small": "true" } },
      [
        _c("div", { staticClass: "logo1" }, [
          _c("img", {
            staticClass: "custom-block-logo",
            attrs: { src: "/static/img/supsis-logo2.png" },
          }),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
        _vm._v(" "),
        _c("div", { staticClass: "logo2" }, [
          _c("img", { attrs: { src: "/static/img/openai.png" } }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }